module.exports = __webpack_public_path__ + "img/cww_14.849404a5.jpg";